<template>
  <v-card flat>
    <v-card-title class="pb-5">
      <v-btn :loading="loading" class="btn-update" @click="updateGateway">
        <v-icon>mdi-update</v-icon>
        بروز رسانی
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="4">
          <v-text-field v-model="name" :error-messages="errors.name" dense label="اسم" outlined required/>
        </v-col>

        <v-col class="pa-2" cols="12" md="4">
          <v-select v-model="type" :error-messages="errors.type" :items="types" dense label="نوع" outlined
                    return-object/>
        </v-col>

        <v-col class="pa-2" cols="12" md="4">
          <v-select v-model="driver" :error-messages="errors.driver" :items="drivers" dense label="درایور" outlined
                    readonly return-object/>
        </v-col>

        <v-col class="pa-2" cols="12" md="4">
          <v-select v-model="showType" :items="Showtypes" dense label="وضعیت نمایش" outlined/>
        </v-col>

        <v-col class="pa-2" cols="12" md="4">
          <v-select v-model="status" :items="gateTypes" dense label="کابران" outlined/>
        </v-col>

        <v-col v-if="status === 'private'" class="pa-2" cols="12" md="4">
          <user-picker v-model="users" depressed is-button/>
        </v-col>

        <v-col v-if="!!users.length" class="px-2" cols="12">
          <v-chip v-for="(user, i) in users" :key="i" class="ma-1 pe-2">
            {{ user }}
            <v-btn class="ms-1" icon small @click="users.splice(i, 1)">
              <v-icon small>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import userPicker from "@/core/plugins/TitleRibbon/pages/pickers/userPicker.vue";

export default {
  components: {userPicker},

  props: ['id'],

  data() {
    return {
      name: '',
      type: null,
      showType: null,
      status: 'public',
      types: [
        {text: 'نمایش', value: 'regular'},
        {text: 'حقوقی', value: 'legal'},
      ],
      Showtypes: [
        {text: 'نمایش', value: 1},
        {text: 'عدم نمایش', value: 0},
      ],
      drivers: [
        {text: 'زرینپال', value: 'zarinpal'},
        {text: 'بانک ملت', value: 'behpardakht'},
        {text: 'سامان', value: 'saman'},
        {text: 'بازارپی', value: 'bazar'},
        {text: 'درون برنامه', value: 'top'},
        { title: "سپ", value: "sep" },

      ],
      gateTypes: [
        {text: 'پیشفرض', value: 'public'},
        {text: 'انتخاب کاربر', value: 'private'},
      ],
      users: [],
      driver: null,
      errors: {},
      loading: false,
      oldUsers:[],
    };
  },

  mounted() {
    this.getGatewayPayment();
    
  },
watch: {
  users: {
    handler(newValue) {
      if (newValue && newValue.length > 0) {
        this.getGetvalidation();
      }
    },
    deep: true 
  }
},
  methods: {
    getGetvalidation() {
      let users = this.users.filter(u=>!this.oldUsers.includes(u))||[];
  const userIdsParam = Array.isArray(users) ? users.join(',') : users;
  if(!!userIdsParam && userIdsParam.length>0){

  this.requestApiGet(`user/official/validation?userIds=${userIdsParam}&gateway=${this.id}`)
    .then(({ data }) => {

    })
    .catch((res) => {
      console.log(res);

      const unofficial = res.response?.data?.errors?.unofficial || [];

      if (unofficial.length) {
        const message =
          unofficial.length === 1
            ? `این کاربر رسمی نیست: ${unofficial[0]}`
            : `این کاربران رسمی نیستند: ${unofficial.join(', ')}`;

        this.$toast.error(message,{
        timeout: 7000,
      });
      }
    }); 
  }
},

    getGatewayPayment() {
      this.loading = true;
      this.requestApiGet(`gatewayPayment/${this.id}`)
        .then(({data}) => {
          this.name = data.name;
          this.type = data.type;
          this.showType = data.show;
          this.driver = data.driver;
          this.status = data?.status ?? 'public';
          this.users = data?.users ?? []
          this.oldUsers = this.users;
        })
        .finally(() => this.loading = false)
    },
    updateGateway() {
      if (this.status === 'private' && (!this.users.length))
        return this.$toast.error('لطفا فیلد انتخاب کاربر را وارد نمایید!')

      this.loading = true;
      this.requestApiPost(`gatewayPayment/${this.id}`, {
        name: this.name,
        show: this.showType,
        type: this.type.value,
        status: this.status,
        users: !!this.status && this.status === 'private' ? this.users : undefined,
        _method: 'PUT',
      })
        .then(({data}) => {
          this.loading = false;
          this.$toast.success('با موفقیت بروزرسانی شد');
          this.$router.push({name: 'payments.index'});
        })
        .catch(({response}) => {
          this.errors = response.data.errors;
        })
        .finally(() => this.loading = false)
    },
  },
};
</script>
